module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qback3-c77fcbc8d184b1de74d3bfedbf39aa35.jpg";